import type { ISbStoriesParams } from 'storyblok-js-client';

/**
 * This file contains Storyblok types that are the same for all packages
 */
// TODO we should generate types into the shared package, allowing us to create union types in this file based on all app types

export const defaultStoryParams: ISbStoriesParams = {
  resolve_relations: [
    'core_page.data_product',
    'core_page.header_alternative',
    'lm_slider.products',
    'util_button.item_overlay',
    'util_link-item-icon.item_overlay',
    'util_link-overlay-item.item_overlay',
    'item_card-content-media.overlay',
    'item_card-content-numbers.overlay',
    'item_card-content-svg.overlay',
    'em_product-widget.data_product',
    'cm_product-applications.products',
    'data_product-variant.product',
  ],
  resolve_links: 'url',
};

export const defaultSettingsParams: ISbStoriesParams = {
  resolve_relations: [
    // 'core_settings.header_rich_default', This gets resolved separately
    'core_settings.footer_default',
    'core_settings.shopping_cart',
    'bm_header-rich.top_product_defaults',
    'bm_header-rich--quick-links.data_products',
    'data_product.page',
  ],
  resolve_links: 'url',
};

export interface AssetStoryblok {
  alt: string | null;
  copyright?: string | null;
  fieldtype: 'asset';
  id: number;
  filename: string | null;
  name: string;
  title: string | null;
  focus: string | null;
  meta_data?: {
    alt_de?: string;
    alt_es?: string;
    alt_nl?: string;
    alt_fr?: string;
    alt_ja?: string;
    alt_zh?: string;
    alt_pl?: string;
  };
  source?: string | null;
  is_external_url?: boolean;
  is_private?: boolean;
  src?: string;
  updated_at?: string;
  width?: number | null;
  height?: number | null;
  aspect_ratio?: number | null;
  public_id?: string | null;
  content_type?: string;
}

export type MultilinkStoryblok =
  | {
      fieldtype: 'multilink';
      id: string;
      url: string;
      cached_url: string;
      target?: '_blank' | '_self';
      anchor?: string;
      rel?: string;
      title?: string;
      prep?: string;
      linktype: 'story';
      story?: {
        name: string;
        created_at?: string;
        published_at?: string;
        id: number;
        uuid: string;
        content?: {};
        slug: string;
        full_slug: string;
        sort_by_date?: null | string;
        position?: number;
        tag_list?: string[];
        is_startpage?: boolean;
        parent_id?: null | number;
        meta_data?: null | {};
        group_id?: string;
        first_published_at?: string;
        release_id?: null | number;
        lang?: string;
        path?: null | string;
        alternates?: any[];
        default_full_slug?: null | string;
        translated_slugs?: null | any[];
      };
    }
  | {
      fieldtype: 'multilink';
      id: string;
      url: string;
      cached_url: string;
      target?: '_blank' | '_self';
      linktype: 'url';
      rel?: string;
      title?: string;
    }
  | {
      fieldtype: 'multilink';
      id: string;
      url: string;
      cached_url: string;
      target?: '_blank' | '_self';
      email?: string;
      linktype: 'email';
    }
  | {
      fieldtype: 'multilink';
      id: string;
      url: string;
      cached_url: string;
      target?: '_blank' | '_self';
      linktype: 'asset';
    };

export type CorePageStoryblok = {
  page_type: unknown;
  body?: unknown[];
  header_in_page?: unknown[];
  header_alternative?: unknown[];
  alert?: unknown[];
  seo_meta?: {
    plugin?: 'seo_metatags';
    title?: string;
    og_image?: string;
    og_title?: string;
    description?: string;
    twitter_image?: string;
    twitter_title?: string;
    twitter_description?: string;
    og_description?: string;
  };
  seo_canonical?: string;
  seo_nofollow?: boolean;
  seo_noindex?: boolean;
  is_dark?: boolean;
  data_product?: unknown;
  component: 'core_page';
  _uid: string;
};

export interface CorePageLayerStoryblok {
  page_type: unknown;
  body?: unknown[];
  component: 'core_page_layer';
  _uid: string;
}

export interface StoreEntryStoryblok {
  name: string;
  location?: {
    latitude?: number | null;
    longitude?: number | null;
    street?: string;
    postal_code?: string;
    city?: string;
    country?: string;
    plugin?: 'geolocation-field-plugin';
  };
  assigned_countries: (number | string)[];
  phone?: string;
  email?: string;
  website?: Exclude<MultilinkStoryblok, { linktype?: 'email' } | { linktype?: 'asset' }>;
  contact_name?: string;
  is_showroom?: boolean;
  component: 'store_entry';
  _uid: string;
}
